<div class="profile">
  <div class="row">
    <div class="infoPublish"
      *ngIf="!userData?.is_profile_completed&&isMyProfile&&userData?.roles[0]?.role_code=='General'">
      <div class=" text">
        <svg id="cautious_sign" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
          <circle id="circle" cx="21" cy="21" r="21" fill="#feecd4" />
          <path id="warning-ic"
            d="M110.757,52.847l6.863,11.785a3.064,3.064,0,0,1,0,3.107,3.118,3.118,0,0,1-2.714,1.554H101.18a3.118,3.118,0,0,1-2.714-1.554,3.064,3.064,0,0,1,0-3.107l6.863-11.785a3.148,3.148,0,0,1,5.428,0Zm-2.714,10.915a1.042,1.042,0,1,0,1.051,1.042A1.047,1.047,0,0,0,108.043,63.761Zm0-1.86a.817.817,0,0,0,.82-.784l.207-4.494a.813.813,0,0,0-.82-.843h-.415a.813.813,0,0,0-.82.843l.207,4.494A.817.817,0,0,0,108.043,61.9Z"
            transform="translate(-87.043 -39.293)" fill="#eb9521" fill-rule="evenodd" />
        </svg>
        <div>
          <h4>{{'items-requests.Your profile is incomplete' | translate}}</h4>
          <p>{{'items-requests.You must complete' | translate}}</p>
        </div>

      </div>
      <div class="action">
        <button mat-button class="btn_fill" (click)="onCompeleteMyProfile()">
          {{'items-requests.Complete My Profile' | translate}}</button>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-9 col-md-12">
        <div class="usercard ">
          <div class="usercard_left">
            <div class="nameShortcut rounded-circle">
              <img class="rounded-circle" *ngIf="userData?.image" [src]="userData?.image "
                (error)='userData.image = ""'>

              <span *ngIf="!userData?.image"> {{userData?.firstname+" "+(userData?.lastname ?
                userData?.lastname : '') |shortName}}
              </span>

              <app-file-manager label="User Profile Image" [renderBtn]="true" (selectedFiles)="onSelectFile($event)"
                [maxFiles]="1" [allowedExt]="['png','jpg','jpeg']" managerIndex='user_profile_image' [MaxFileSize]="5"
                [Mode]="'small'"></app-file-manager>
            </div>

          </div>
          <div class="content ">
            <div class="info">
              <div class="badgeOrange" *ngIf="!userData?.is_active">
                {{'items-requests.Suspended' | translate}}
                <a [matTooltip]="userData?.reason_suspend | lowercase " matTooltipPosition="right"
                  matTooltipClass="tooltipCustom"><img src="assets/images/icons/info.svg" alt=""></a>
              </div>
              <div class="title">{{userData?.firstname+" "+(userData?.lastname ? userData?.lastname :
                '')|titlecase}}
              </div>
              <div class="infoItem role" *ngIf="userData?.roles[0]?.role_code!='General'">
                {{userData?.roles[0]?.role_name}}
              </div>
              <div class="infoItem">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <g id="email-ic" transform="translate(-4)">
                    <rect id="container" width="16" height="16" transform="translate(4)" fill="none" />
                    <path id="Path_19057" data-name="Path 19057"
                      d="M16.4,4H3.6A1.55,1.55,0,0,0,2.008,5.5L2,14.5A1.557,1.557,0,0,0,3.6,16H16.4A1.557,1.557,0,0,0,18,14.5v-9A1.557,1.557,0,0,0,16.4,4Zm-.32,3.188L10.424,11.5a.855.855,0,0,1-.848,0L3.92,7.188a.634.634,0,0,1-.32-.54.681.681,0,0,1,1.04-.54L10,10.25l5.36-4.143a.681.681,0,0,1,1.04.54A.634.634,0,0,1,16.08,7.188Z"
                      transform="translate(2 -2)" fill="#ed793e" />
                  </g>
                </svg>

                <p>{{userData?.email}}</p>
                <a class="mx-2 editMail"
                  *ngIf="userData?.roles[0]?.role_code=='General'||userData?.roles[0]?.role_code=='Admin'"
                  (click)="ChangeMail()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16.004" viewBox="0 0 16 16.004">
                    <path id="edit-icon"
                      d="M5.82,14l-3.63-3.63,8.78-8.78,3.63,3.63ZM1.851,11.011l3.33,3.33L.188,16Zm13.865-6.9-.63.63L11.451,1.1l.63-.63a1.624,1.624,0,0,1,2.3,0l1.338,1.338a1.633,1.633,0,0,1,0,2.3Zm0,0"
                      transform="translate(-0.188 0.001)" fill="#322075" opacity="0.85" />
                  </svg>
                </a>
              </div>
              <div class="infoItem">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                  <path id="Path_19058" data-name="Path 19058"
                    d="M17.459,13.921,15.2,13.663a1.773,1.773,0,0,0-1.461.508L12.1,15.809a13.4,13.4,0,0,1-5.87-5.87L7.875,8.292a1.773,1.773,0,0,0,.508-1.461L8.124,4.587A1.783,1.783,0,0,0,6.352,3.01H4.811A1.768,1.768,0,0,0,3.03,4.854,15.134,15.134,0,0,0,17.183,19.007a1.768,1.768,0,0,0,1.844-1.781V15.684A1.765,1.765,0,0,0,17.459,13.921Z"
                    transform="translate(-3.026 -3.01)" fill="#ed793e" />
                </svg>
                <p>({{userData?.country_code}}) {{userData?.phone}}</p>
                <a class="mx-2 editMail"
                  *ngIf="userData?.roles[0]?.role_code=='General'||userData?.roles[0]?.role_code=='Admin'"
                  (click)="ChangePhone()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16.004" viewBox="0 0 16 16.004">
                    <path id="edit-icon"
                      d="M5.82,14l-3.63-3.63,8.78-8.78,3.63,3.63ZM1.851,11.011l3.33,3.33L.188,16Zm13.865-6.9-.63.63L11.451,1.1l.63-.63a1.624,1.624,0,0,1,2.3,0l1.338,1.338a1.633,1.633,0,0,1,0,2.3Zm0,0"
                      transform="translate(-0.188 0.001)" fill="#322075" opacity="0.85" />
                  </svg>
                </a>
              </div>
              <div class="infoItem" *ngIf="userData?.resident_number || userData?.national_number">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12">
                  <path id="Path_19848" data-name="Path 19848"
                    d="M16.4,7H3.6A1.6,1.6,0,0,0,2,8.6v8.8A1.6,1.6,0,0,0,3.6,19H16.4A1.6,1.6,0,0,0,18,17.4V8.6A1.6,1.6,0,0,0,16.4,7ZM7.6,11a1.2,1.2,0,1,1-1.2,1.2A1.2,1.2,0,0,1,7.6,11ZM10,15.8H5.2v-.344a1.213,1.213,0,0,1,.736-1.112,4.2,4.2,0,0,1,3.328,0A1.217,1.217,0,0,1,10,15.456Zm4.2-1.2h-2a.6.6,0,0,1-.6-.6h0a.6.6,0,0,1,.6-.6h2a.6.6,0,0,1,.6.6h0A.6.6,0,0,1,14.2,14.6Zm0-2.4h-2a.6.6,0,0,1-.6-.6h0a.6.6,0,0,1,.6-.6h2a.6.6,0,0,1,.6.6h0A.6.6,0,0,1,14.2,12.2Z"
                    transform="translate(-2 -7)" fill="#ed793e" />
                </svg>
                <p>
                  <span>{{(userData?.is_national_number=='1'?"forms.National ID" :
                    "forms.Resident ID (Iqama)")|translate}}: </span>
                  {{userData?.is_national_number=='1'?userData?.national_number :
                  userData?.resident_number}}
                </p>
              </div>
              <div class="infoItem" *ngIf="userData?.is_profile_completed">
                <svg xmlns="http://www.w3.org/2000/svg" width="11.2" height="16" viewBox="0 0 11.2 16">
                  <path id="Path_23431" data-name="Path 23431"
                    d="M10.6,2A5.6,5.6,0,0,0,5,7.6C5,11.8,10.6,18,10.6,18s5.6-6.2,5.6-10.4A5.6,5.6,0,0,0,10.6,2Zm0,7.6a2,2,0,1,1,2-2A2,2,0,0,1,10.6,9.6Z"
                    transform="translate(-5 -2)" fill="#ed793e" />
                </svg>

                <p>
                  {{userData?.street+', '+userData?.city+', '+userData?.region+', '+userData?.country}}
                </p>
              </div>

              <div class="infoItem ">
                <span class="date"><i>{{'items-requests.Member since' | translate}} :</i>
                  {{userData?.created_at|dateUTC}}</span>
              </div>
            </div>
            <div class="actions group_btn">
              <button mat-button class="btnLight_fill" (click)="onEditAccount()"><svg xmlns="http://www.w3.org/2000/svg"
                  width="15.999" height="15.998" viewBox="0 0 15.999 15.998">
                  <path id="Union_27" data-name="Union 27"
                    d="M-13932.556,14139a.44.44,0,0,1-.445-.443v-2.7a.432.432,0,0,1,.136-.319l9.7-9.7,3.329,3.334-9.705,9.7a.413.413,0,0,1-.309.132Zm10.336-14.114,1.627-1.625a.886.886,0,0,1,1.253,0l2.077,2.079a.883.883,0,0,1,0,1.253l-1.624,1.627Z"
                    transform="translate(13933.001 -14123.002)" fill="#70639e" />
                </svg>
                {{'Auctions.Edit' | translate }}</button>
              <button mat-icon-button [matMenuTriggerFor]="menu" class="btnLight_fill"><svg
                  xmlns="http://www.w3.org/2000/svg" width="16" height="4" viewBox="0 0 16 4">
                  <path id="Path_19055" data-name="Path 19055"
                    d="M6,10a2,2,0,1,0,2,2A2.006,2.006,0,0,0,6,10Zm12,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,18,10Zm-6,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z"
                    transform="translate(-4 -10)" fill="#322075" />
                </svg>
              </button>

              <mat-menu #menu="matMenu">
                <!-- <button mat-menu-item *ngIf="!isMyProfile" (click)="OnSuspendOrUnsuspend()">
                                {{userData?.is_active?"Suspend":"Unsuspend"}}</button> -->
                <button mat-menu-item *ngIf="isMyProfile && userData?.roles[0]?.role_code=='General'"
                  (click)="PrivacySetting()">
                  {{'items-requests.Privacy Setting' | translate}}</button>
                <button mat-menu-item (click)="onChangePassword()">
                  {{'users.changePass' | translate}}</button>
                <!-- <button mat-menu-item *ngIf="!isMyProfile" (click)="OnDeleteUser()"><span
                                    class="text-danger">Delete</span> </button> -->
                <!-- <button mat-menu-item *ngIf="isMyProfile" (click)="PrivacySetting()">Privacy
                                Setting</button>
                            <button mat-menu-item (click)="onChangePassword()">Change
                                Password</button> -->
              </mat-menu>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-12">
        <div class="wallet">
          <img src="assets/images/icons/wallet.svg" alt="Wallet Icoin">
          <p class="text">{{'Auction Item.Current wallet balance' | translate}}</p>
          <p class="balance">{{"Auction Item.SR"|translate}} <span>{{userData?.balance?userData?.balance:0|number}}</span></p>
          <button mat-button class="btnOrang_fill" (click)="onViewWallet()">
            {{'items-requests.VIEW WALLET' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>